import * as React from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';

import { ColumnHeader } from 'pages/Shipments/Containers/Table/cells/ColumnHeader';
import * as Cells from './cells';

const CONTAINER_CELL_WIDTH = 200;

const DefaultColDef: Partial<GridColDef> = {
  sortable: false,
  width: CONTAINER_CELL_WIDTH,
  disableColumnMenu: true,
};

export const getColumns: (tooltip: string) => GridColDef[] = (tooltip: string) => {
  const columns: GridColDef[] = [
    {
      ...DefaultColDef,
      field: 'bol',
      renderCell: (params) => <Cells.BolCell {...params} />,
      renderHeader: () => (
        <ColumnHeader
          name="Ocean BOL"
          tooltip="Your Ocean BOL numbers."
          showTooltip={tooltip === 'bol'}
        />
      ),
    },
    {
      ...DefaultColDef,
      field: 'container',
      renderCell: (params) => <Cells.ContainerCell {...params} />,
      renderHeader: () => (
        <ColumnHeader
          name="Container"
          tooltip="Your container numbers."
          showTooltip={tooltip === 'container'}
        />
      ),
    },
    {
      ...DefaultColDef,
      field: 'trackStatus',
      renderCell: (params) => <Cells.TrackStatusCell {...params} />,
      renderHeader: () => (
        <ColumnHeader
          name="Tracking Status"
          tooltip="The status of your shipment being successfully tracked by BlueCargo."
          showTooltip={tooltip === 'trackStatus'}
        />
      ),
    },
    {
      ...DefaultColDef,
      field: 'ssl',
      renderCell: (params) => <Cells.SslCell {...params} />,
      renderHeader: () => (
        <ColumnHeader name="SSL" tooltip="Steamship line." showTooltip={tooltip === 'ssl'} />
      ),
    },
    {
      ...DefaultColDef,
      field: 'customer',
      renderCell: (params) => <Cells.ReferenceCell {...params} />,
      renderHeader: () => (
        <ColumnHeader
          name="Reference ID"
          tooltip="A generic ID that you have associated with your container/shipment."
          showTooltip={tooltip === 'customer'}
        />
      ),
    },
    {
      ...DefaultColDef,
      field: 'dateAdded',
      renderCell: (params) => <Cells.DateAddedCell {...params} />,
      renderHeader: () => (
        <ColumnHeader
          name="Date Added"
          tooltip="When the shipment was added."
          showTooltip={tooltip === 'dateAdded'}
        />
      ),
    },
    {
      ...DefaultColDef,
      field: 'uploadedBy',
      renderCell: (params) => <Cells.UploadedByCell {...params} />,
      renderHeader: () => (
        <ColumnHeader
          name="Uploaded By"
          tooltip="Who added the shipment."
          showTooltip={tooltip === 'uploadedBy'}
        />
      ),
    },
  ];
  return columns;
};
